<template>
  <div>
    <div
      class="
        vs-component
        con-vs-popup
        vs-popup-primary
        cstm-modal-popup
        schedule-popup
      "
      v-if="viewTemplate"
      :class="{ show: viewTemplate }"
    >
      <div class="cstm-modal">
        <div class="header">
          <h4>Create Template</h4>
          <button @click="closeTemplate" class="close-modal">
            &times;
          </button>
        </div>
        <div class="modal-content">
          <vs-tabs v-model="tabIndex">
            <vs-tab icon="email" label="Email">
              <div>
                <div class="mb-4">
                  <strong class="block mb-2">{{ module_name }}</strong>
                  <p>{{ module_action_name }} for {{ module_name }}</p>
                </div>
                <div class="mb-4">
                  <strong class="block mb-2">Subject</strong>
                  <vs-textarea
                    placeholder="Write a subject"
                    v-model="templateData.subject"
                  ></vs-textarea>
                </div>
                <div class="mb-4">
                  <vs-tabs class="small_tabs_holder">
                    <vs-tab label="Text">
                      <editor
                        v-model="templateData.template"
                        :api-key="tinyMceApi"
                        :init="initTinyMce"
                      />
                    </vs-tab>
                    <vs-tab label="Preview"
                      ><div v-html="templateData.template"></div
                    ></vs-tab>
                  </vs-tabs>
                </div>

                <div class="flex flex-wrap justify-center items-center">
                  <div
                    style="cursor: pointer"
                    @click="dynamicList = !dynamicList"
                    class="rounded_holder filled_bg my-1 ml-2"
                  >
                    <span class="material-icons-outlined"
                      >integration_instructions</span
                    >
                    <span class="pl-1">Dynamic Fields</span>

                    <!-- dynamic fields tooltip -->
                    <div
                      style="bottom: 135px;"
                      class="cstm_shadow_tooltip dynamic_fields_tooltip middle_tooltip"
                      :class="[dynamicList ? 'show' : '']"
                    >
                      <h4 class="border_btm pb-4 mb-4">
                        {{ module_name }}
                      </h4>
                      <div class="flex flex-wrap">
                        <div
                          class="outer-field-cstm-badge"
                          style="padding: 0 5px"
                          :key="index"
                          v-for="(item, index) in fieldCodes"
                          @click.stop="abc"
                        >
                          <div class="field-cstm-badge">
                            <a @click="appendCodeToTemplate(item.field_code)">{{
                              item.field_name
                            }}</a>
                            <!-- <a class="info"
                              ><span class="material-icons">info</span></a
                            >
                            <p class="description">
                              {{ item.field_description }}
                            </p> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <vs-divider />

                <vs-button class="block ml-auto" @click="createTemplate">Save</vs-button>
              </div>
            </vs-tab>
            <vs-tab icon="sms" label="Sms">
              <div>
                <div class="mb-4">
                  <strong class="block mb-2">{{ module_name }}</strong>
                  <p>{{ module_action_name }} for {{ module_name }}</p>
                </div>
                <div class="mb-4">
                  <strong class="block mb-2">Write SMS</strong>
                  <vs-textarea
                    placeholder="Write a sms"
                    v-model="templateData.template"
                    ref="template_textarea"
                  ></vs-textarea>
                </div>

                <div class="flex flex-wrap justify-center items-center">
                  <div
                    style="cursor: pointer"
                    @click="dynamicList = !dynamicList"
                    class="rounded_holder filled_bg my-1 ml-2"
                  >
                    <span class="material-icons-outlined"
                      >integration_instructions</span
                    >
                    <span class="pl-1">Dynamic Fields</span>

                    <!-- dynamic fields tooltip -->
                    <div
                      style="bottom: 135px;"
                      class="cstm_shadow_tooltip dynamic_fields_tooltip middle_tooltip"
                      :class="[dynamicList ? 'show' : '']"
                    >
                      <h4 class="border_btm pb-4 mb-4">
                        {{ module_name }}
                      </h4>
                      <div style="max-height: 85px; overflow: auto;" class="flex flex-wrap vertical_scrollbar">
                        <div
                          class="outer-field-cstm-badge"
                          style="padding: 0 5px"
                          :key="index"
                          v-for="(item, index) in fieldCodes"
                          @click.stop="abc"
                        >
                          <div class="field-cstm-badge">
                            <a
                              @click="appendCodeToSMSTemplate(item.field_code)"
                              >{{ item.field_code }}</a
                            >
                            <a class="info"
                              ><span class="material-icons">info</span></a
                            >
                            <p class="description">
                              {{ item.field_description }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <vs-divider />

                <vs-button class="block ml-auto" @click="createTemplate">Save</vs-button>
              </div>
            </vs-tab>
            <vs-tab icon="push_pin" label="Push">
              <div>
                <div class="mb-4">
                  <strong class="block mb-2">Platform</strong>
                  <p>Remind Report Delay</p>
                </div>
                <div class="mb-4">
                  <strong class="block mb-2"
                    >Write Notification Template</strong
                  >
                  <vs-textarea
                    placeholder="Write a notification template"
                    v-model="templateData.template"
                    ref="template_textarea"
                  ></vs-textarea>
                </div>

                <div class="flex flex-wrap justify-center items-center">
                  <div
                    style="cursor: pointer"
                    @click="dynamicList = !dynamicList"
                    class="rounded_holder filled_bg my-1 ml-2"
                  >
                    <span class="material-icons-outlined"
                      >integration_instructions</span
                    >
                    <span class="pl-1">Dynamic Fields</span>

                    <!-- dynamic fields tooltip -->
                    <div
                      style="bottom: 135px;"
                      class="cstm_shadow_tooltip dynamic_fields_tooltip middle_tooltip"
                      :class="[dynamicList ? 'show' : '']"
                    >
                      <h4 class="border_btm pb-4 mb-4">
                        {{ module_name }}
                      </h4>
                      <div style="max-height: 85px; overflow: auto;" class="flex flex-wrap vertical_scrollbar">
                        <div
                          class="outer-field-cstm-badge"
                          style="padding: 0 5px"
                          :key="index"
                          v-for="(item, index) in fieldCodes"
                          @click.stop="abc"
                        >
                          <div class="field-cstm-badge">
                            <a
                              @click="appendCodeToSMSTemplate(item.field_code)"
                              >{{ item.field_code }}</a
                            >
                            <a class="info"
                              ><span class="material-icons">info</span></a
                            >
                            <p class="description">
                              {{ item.field_description }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <vs-divider />
                <vs-button class="block ml-auto" @click="createTemplate">Save</vs-button>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script
  src="https://cdn.tiny.cloud/1/dby84f0rwttg363c3yyx0t5jucrrxd2rsclfsoi76uhjy4ez/tinymce/5/tinymce.min.js"
  referrerpolicy="origin"
></script>
<script>
import {
  getRelatedRecords,
  emailTemplateCreatefromCommunication,
  emailTemplateEdit,
  emailTemplateEditfromCommunication
} from "@/api/email.js";

import { smsTemplateCreate, smsTemplateEdit } from "@/api/sms.js";
import {
  notificationTemplateCreate,
  notificationTemplateEdit
} from "@/api/notification-template.js";
import { templateDetailsFetch } from "@/api/setting.js";

import Editor from "@tinymce/tinymce-vue";

export default {
  components: {
    Editor
  },
  props: {
    viewTemplate: {
      default: false
    },
    module_action_name: {
      default: ""
    },
    module_name: {
      default: ""
    },
    role_action_id: {
      default: 0
    },
    platform_module_id: {
      default: 0
    }
  },
  data() {
    return {
      fieldCodes:[],
      dynamicList: false,
      tinyMceApi: "",
      initTinyMce: {
        setup: editor => {
          editor.ui.registry.addIcon(
            "filesIcon",
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          );

          editor.ui.registry.addIcon(
            "gDriveIcon",
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          );

          editor.ui.registry.addButton("gDrive", {
            icon: "gDriveIcon",
            tooltip: "Insert from GDrive",
            onAction: () => {
              this.gDrive(editor);
            }
          });
        },
        height: 300,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.example_image_upload_handler,
        plugins: [
          "autolink lists link image charmap print preview anchor",
          "imagetools",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount",
          "code lists fullscreen",
          "emoticons"
        ],
        menu: "table",
        toolbar:
          "customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \
                        table alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help"
      },
      attachICSFile: [],
      editTemplateId: null,
      platform_modules_id: this.platform_module_id,
      tabIndex: 0,
      templateData: {
        type_id: this.role_action_id,
        subject: "",
        template: "",
        is_default: 1,
        platform_modules_id: this.platform_module_id
      }
    };
  },
  mounted() {
    this.templateDetails();
    this.getCommunicationDynamicField();
  },
  watch: {
    tabIndex() {
      this.templateDetails();
      this.getCommunicationDynamicField();
      this.dynamicList = false;
    }
  },
  created() {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API;
  },
  methods: {
    async templateDetails() {
      this.templateData.subject = null;
      this.templateData.template = null;
      this.templateData.is_default = 1;
      this.editTemplateId = null;

      const customer_id = localStorage.getItem("customer_id");
      const payload = {
        platform_module_id: this.platform_module_id,
        role_action_id: this.role_action_id
      };
      let flag = null;
      if (this.tabIndex === 0) {
        flag = "EMAIL";
      } else if (this.tabIndex === 1) {
        flag = "SMS";
      } else {
        flag = "PUSH";
      }
      const { data } = await templateDetailsFetch(customer_id, flag, payload);
      if (data) {
        if (this.tabIndex === 0) {
          const res = data.data.fields;
          this.templateData.subject = res.subject;
          this.templateData.template = res.email_template;
          this.templateData.is_default = res.is_default;
          this.editTemplateId = res.email_template_id;
        } else if (this.tabIndex === 1) {
          const res = data.data.fields;
          this.templateData.template = res.sms_template;
          this.editTemplateId = res.sms_template_id;
        } else if (this.tabIndex === 2) {
          const res = data.data.fields;
          this.templateData.template = res.push_template;
          this.editTemplateId = res.push_template_id;
        }
      }
    },
    editTemplate() {
      if (this.tabIndex === 0) {
        emailTemplateEditfromCommunication(
          localStorage.getItem("customer_id"),
          this.editTemplateId,
          this.templateData
        );
      } else if (this.tabIndex === 1) {
        smsTemplateEdit(
          localStorage.getItem("customer_id"),
          this.editTemplateId,
          this.templateData
        );
      } else if (this.tabIndex === 2) {
        notificationTemplateEdit(
          localStorage.getItem("customer_id"),
          this.editTemplateId,
          this.templateData
        );
      }

      this.$vs.notify({
        title: "Success",
        text: "Template Created Successfully",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      });
      // emailTemplateEdit(
      //   localStorage.getItem("customer_id"),
      //   this.editTemplateId,
      //   this.templateData
      // )
      //   .then((res) => {
      //     this.emailSidebar = false;
      //     this.$vs.notify({
      //       title: "Success",
      //       text: "Template Edited Successfully",
      //       iconPack: "feather",
      //       icon: "icon-alert-circle",
      //       color: "success",
      //     });
      //   })
      //   .catch((e) => {
      //     this.$vs.notify({
      //       title: "Warning",
      //       text: "Something Went Wrong",
      //       iconPack: "feather",
      //       icon: "icon-alert-circle",
      //       color: "warning",
      //     });
      //   });

      setTimeout(() => {
        this.editTemplateId = null;
      }, 2000);
    },
    closeTemplate() {
      this.$emit("closeTemplate", true);
    },
    resetData() {
      this.templateData.subject = "";
      this.templateData.template = "";
      this.templateData.platform_modules_id = "";
      this.editTemplateId = null;
    },
    createTemplate() {
      try {
        if (this.editTemplateId !== null) {
          this.editTemplate();
        } else {
          if (this.tabIndex === 0) {
            emailTemplateCreatefromCommunication(
              localStorage.getItem("customer_id"),
              this.templateData
            );
          } else if (this.tabIndex === 1) {
            smsTemplateCreate(
              localStorage.getItem("customer_id"),
              this.templateData
            );
          } else if (this.tabIndex === 2) {
            notificationTemplateCreate(
              localStorage.getItem("customer_id"),
              this.templateData
            );
          }

          this.$vs.notify({
            title: "Success",
            text: "Template Created Successfully",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        }
      } catch (e) {
        this.$vs.notify({
          title: "Warning",
          text: "Something Went Wrong",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
      }
    },
    appendCodeToSMSTemplate(field_code) {
      const template_textarea_ele = this.$refs.template_textarea.$el
        .children[0];
      template_textarea_ele.setRangeText(field_code);
      this.templateData.template = template_textarea_ele.value;

      //Notifications after appending code
      this.$vs.notify({
        title: "Success",
        text: "Code added",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
        time: 2000
      });

      this.dynamicList = false;
    },
    appendCodeToTemplate(field_code) {
      if (this.tabIndex === 0)
        tinymce.activeEditor.execCommand("mceInsertContent", false, field_code);
      this.$vs.notify({
        title: "Success",
        text: "Code added",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
        time: 2000
      });
      this.dynamicList = false;
    },
    async getCommunicationDynamicField() {
      try {
        const payload = {
          customer_id: localStorage.getItem("customer_id"),
          module_id: this.platform_module_id
        };
        const response = await getRelatedRecords(payload);
        this.fieldCodes = response.data.data.module_related_dynamic_field;
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>
